/*
    数组统计某个字段总和或者统计整个数组总和
    key:数组对象中需要计算总和的字段名称，不传或者传null,空字符串则认为是一个简单数组，同是否则是一个对象数组
*/
Array.prototype.sum = function (key) {
  if (this === null || this === undefined) throw new TypeError("Object is null or undefined");
  var r = 0;
  this.forEach(function (item) {
    if (typeof key !== "undefined" && key && key.length > 0) {
      r += parseInt(item[key]);
    } else {
      r += parseInt(item);
    }
  });
  return r;
};

Array.prototype.remove = function (removeItem, itemKey) {

  if (this === null || this === undefined) throw new TypeError("Object is null or undefined");
  if (typeof removeItem === "undefined" || removeItem === null || removeItem === undefined) throw new TypeError("removeItem is null or undefined");
  var _this = this;
  this.forEach(function (item, index) {
    if (typeof itemKey !== "undefined" && itemKey !== null && typeof itemKey === "string") {
      if (removeItem[itemKey] === item[itemKey])
        _this.splice(index, 1);
    } else {
      if (item === removeItem)
        _this.splice(index, 1);
    }
  });
  return _this;
}
Date.prototype.Format = function (formatStr) {
  var str = formatStr;
  var Week = ['日', '一', '二', '三', '四', '五', '六'];
  var month = this.getMonth() + 1;

  str = str.replace(/yyyy|YYYY/, this.getFullYear());
  str = str.replace(/yy|YY/, (this.getYear() % 100) > 9 ? (this.getYear() % 100).toString() : '0' + (this.getYear() % 100));


  str = str.replace(/MM/, month > 9 ? month : '0' + month);
  str = str.replace(/M/g, month);

  str = str.replace(/w|W/g, Week[this.getDay()]);

  str = str.replace(/dd|DD/, this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate());
  str = str.replace(/d|D/g, this.getDate());

  str = str.replace(/hh|HH/, this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours());
  str = str.replace(/h|H/g, this.getHours());
  str = str.replace(/mm/, this.getMinutes() > 9 ? this.getMinutes().toString() : '0' + this.getMinutes());
  str = str.replace(/m/g, this.getMinutes());

  str = str.replace(/ss|SS/, this.getSeconds() > 9 ? this.getSeconds().toString() : '0' + this.getSeconds());
  str = str.replace(/s|S/g, this.getSeconds());

  str = str.replace(/t/g, this.getHours() < 12 ? 'am' : 'pm');
  str = str.replace(/T/g, this.getHours() < 12 ? 'AM' : 'PM');

  return str;
}


// WEBPACK FOOTER //
// ./src/utils/Array.js